exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ck-editor__editable .image>figcaption{color:#333;background-color:#f7f7f7;padding:.8em;font-size:.75em;outline-offset:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/css-loader?{"minimize":true}!/workspace/ckeditor5/node_modules/sass-loader/lib/loader.js!../ckeditor5-image/theme/imagecaption/theme.scss
// module id = 537
// module chunks = 0